import {FC} from 'react';
import {SxProps, Theme, Typography} from '@mui/material';
import {FormattedMessage, useIntl} from 'react-intl';
import {RegistrationStatusEnum} from 'src/enums';
import theme from 'src/theme';
import {pillFitSx} from 'src/components/common/pillFit.sx';
import {useFitText} from 'src/hooks/useFitText';

export const EmployeeStatus: FC<{ label: RegistrationStatusEnum }> = ({label}) => {
    const intl = useIntl();
    const fitRef = useFitText<HTMLSpanElement>(`${intl.locale}:${label}`);
    const calculateBackgroundAndColor = () => {
        switch (label) {
            case RegistrationStatusEnum.ACTIVATED: {
                return {
                    background: theme.palette.success.light,
                    color: theme.palette.success.dark,
                };
            }
            case RegistrationStatusEnum.DEACTIVATED: {
                return {
                    background: theme.palette.warning.light,
                    color: theme.palette.warning.dark,
                };
            }
            case RegistrationStatusEnum.PENDING_HASH: {
                return {
                    background: theme.palette.primaryColor[50],
                    color: theme.palette.primaryColor[700],
                };
            }
            case RegistrationStatusEnum.PENDING_ADDRESS: {
                return {
                    background: theme.palette.primaryColor[100],
                    color: theme.palette.primary.dark,
                };
            }
            default: {
                return {
                    background: theme.palette.success.light,
                    color: theme.palette.success.dark,
                };
            }
        }
    };

    const sxValue: SxProps<Theme> = {
        ...calculateBackgroundAndColor(),
        padding: theme.spacing(3 / 8, 6 / 8),
        borderRadius: theme.spacing(4 / 8),
        fontWeight: 500,
        ...pillFitSx,
        [theme.breakpoints.down('md')]: {
            fontSize: theme.spacing(12 / 8),
        },
    };

    return (
        <Typography
            ref={fitRef}
            sx={sxValue}
            component="span"
        >
            <FormattedMessage id={label}/>
        </Typography>
    );
};
